export class FetchError extends Error {
  constructor(m: string) {
    super(m);

    this.name = 'FetchError';
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}
